// extracted by mini-css-extract-plugin
export var button = "_g5-2";
export var card = "_g5-0";
export var closeButtonContainer = "_g5-3";
export var iconContainer = "_g5-1";